import { render, staticRenderFns } from "./PraticheSingoloUtente.vue?vue&type=template&id=519a0ff2&scoped=true&"
import script from "./PraticheSingoloUtente.vue?vue&type=script&lang=js&"
export * from "./PraticheSingoloUtente.vue?vue&type=script&lang=js&"
import style0 from "./PraticheSingoloUtente.vue?vue&type=style&index=0&id=519a0ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a0ff2",
  null
  
)

export default component.exports